export default __webpack_public_path__ + "static/media/profilpic.714094ed.jpg";